import { render, staticRenderFns } from "./CryptoTab.vue?vue&type=template&id=5e06426d&scoped=true"
import script from "./CryptoTab.vue?vue&type=script&lang=js"
export * from "./CryptoTab.vue?vue&type=script&lang=js"
import style0 from "./CryptoTab.vue?vue&type=style&index=0&id=5e06426d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06426d",
  null
  
)

export default component.exports